import resourceRepositoryFactory from './services/resource-repository-factory.service';

const repoUtil = angular.module('cbpRepositoryUtils', []);

repoUtil.factory('CbpResourceRepositoryFactory', resourceRepositoryFactory);

export default repoUtil;
